import { useOpenPositionSyncMutation } from "@/common/api/open-position/use-open-position-sync.mutation";
import { toastMutationStatus } from "@/common/helpers/toast-mutation-status";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export function useSyncOpenPosition(): {
  syncOpenPosition: (openPositionUuid: string) => Promise<void>;
  isSyncing: boolean;
} {
  const { t } = useTranslation(["fia"]);
  const { mutateAsync, isPending } = useOpenPositionSyncMutation();

  const syncOpenPosition = useCallback(
    async (openPositionUuid: string) => {
      await toastMutationStatus({
        mutationFn: () => mutateAsync({ openPositionUuid }),
        // The SAP re-fetch is asynchronous, so success only means the request was queued.
        successMessage: t("fia:OpenPositionSyncStarted"),
        errorMessage: t("fia:OpenPositionSyncError"),
      });
    },
    [mutateAsync, t],
  );

  return { syncOpenPosition, isSyncing: isPending };
}
